var __spreadArrays = this && this.__spreadArrays || function () {
  for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;

  for (var r = Array(s), k = 0, i = 0; i < il; i++) for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++) r[k] = a[j];

  return r;
};

import { equals, values } from '../utils';
import CustomVirtualAudioNode from './CustomVirtualAudioNode';

var AudioWorkletVirtualAudioNode =
/** @class */
function () {
  function AudioWorkletVirtualAudioNode(node, output, params, input) {
    this.node = node;
    this.output = output;
    this.params = params;
    this.input = input;
    this.connected = false;
    this.connections = [];
  }

  AudioWorkletVirtualAudioNode.prototype.connect = function () {
    var connectArgs = [];

    for (var _i = 0; _i < arguments.length; _i++) {
      connectArgs[_i] = arguments[_i];
    }

    var audioNode = this.audioNode;
    var filteredConnectArgs = connectArgs.filter(Boolean);
    var firstArg = filteredConnectArgs[0],
        rest = filteredConnectArgs.slice(1);

    if (audioNode.connect) {
      audioNode.connect.apply(audioNode, __spreadArrays([firstArg], rest));
    }

    this.connections = this.connections.concat(filteredConnectArgs);
    this.connected = true;
  };

  AudioWorkletVirtualAudioNode.prototype.disconnect = function (node) {
    var audioNode = this.audioNode;

    if (node) {
      if (node instanceof CustomVirtualAudioNode) {
        var _loop_1 = function (childNode) {
          if (!this_1.connections.some(function (x) {
            return x === childNode.audioNode;
          })) return "continue";
          this_1.connections = this_1.connections.filter(function (x) {
            return x !== childNode.audioNode;
          });
        };

        var this_1 = this;

        for (var _i = 0, _a = values(node.virtualNodes); _i < _a.length; _i++) {
          var childNode = _a[_i];

          _loop_1(childNode);
        }
      } else {
        if (!this.connections.some(function (x) {
          return x === node.audioNode;
        })) return;
        this.connections = this.connections.filter(function (x) {
          return x !== node.audioNode;
        });
      }
    }

    if (audioNode.disconnect) audioNode.disconnect();
    this.connected = false;
  };

  AudioWorkletVirtualAudioNode.prototype.disconnectAndDestroy = function () {
    var audioNode = this.audioNode;
    if (audioNode.disconnect) audioNode.disconnect();
    this.connected = false;
  };

  AudioWorkletVirtualAudioNode.prototype.initialize = function (audioContext) {
    var params = this.params || {};
    this.audioNode = new window.AudioWorkletNode(audioContext, this.node);
    this.params = undefined;
    return this.update(params);
  };

  AudioWorkletVirtualAudioNode.prototype.update = function (params) {
    if (params === void 0) {
      params = {};
    }

    var audioNode = this.audioNode;

    var _loop_2 = function (key) {
      var param = params[key];
      if (this_2.params && this_2.params[key] === param) return "continue";
      var paramInstance = audioNode.parameters.get(key);

      if (Array.isArray(param)) {
        if (this_2.params && !equals(param, this_2.params[key])) {
          ;
          audioNode.parameters.get(key).cancelScheduledValues(0);
        }

        var callMethod = function (_a) {
          var methodName = _a[0],
              args = _a.slice(1);

          return paramInstance[methodName].apply(paramInstance, args);
        };

        Array.isArray(param[0]) ? param.forEach(callMethod) : callMethod(param);
        return "continue";
      }

      paramInstance.value = param;
    };

    var this_2 = this;

    for (var _i = 0, _a = Object.keys(params); _i < _a.length; _i++) {
      var key = _a[_i];

      _loop_2(key);
    }

    this.params = params;
    return this;
  };

  return AudioWorkletVirtualAudioNode;
}();

export default AudioWorkletVirtualAudioNode;